import React from "react";
import category1 from "../../assets/images/category1.svg";
import category2 from "../../assets/images/category2.svg";

export const CategoryNotAvailable = () => {
  return (
    <div className="h-[82.5vh] flex flex-col justify-center items-center    bg-cover w-[100vw]">
      <div className="absolute top-[25%] ">
        <img
          src={category1}
          alt="no-search"
          className="w-[15rem]  border-[1px] border-white "
        />
        <img
          src={category2}
          alt="no-search-text"
          className="w-[15rem] mt-10 "
        />
      </div>
    </div>
  );
};
